import axios from 'axios'

const axiosInstance = axios.create({
    baseURL: '/rest/lookup/',
    headers: {
        'Access-Control-Allow-Origin': '*'
    }
})

export const getLookup = (id: string): Promise<any> => {    
    return axiosInstance.get(`/${id}`)
}
